import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { PermissionsService } from '../services/permissions.service';

@Injectable({
    providedIn: 'root',
})
export class PermissionsGuard implements CanActivate {
    constructor(private permissionsService: PermissionsService) { }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        return this.canActivate(childRoute, state);
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.permissionsService.checkUserAdmin();
        return this.permissionsService.getUserPermissions$().pipe(
            map(() => {
                return true;
            })
        );
    }
}
